import React, { FC } from 'react';

import { BottomItem } from '../../../../components/IntroBlock/components/BottomItem';
import { Usp_Block } from '../../../../types';
import useStyles from './styles';

interface HeaderUspBlockProps {
  uspBlocks: (Usp_Block | null)[];
}

const HeaderUspBlock: FC<HeaderUspBlockProps> = ({ uspBlocks }) => {
  const classes = useStyles();

  return (
    <div className={classes.bottomItemsWrapper}>
      {uspBlocks.map((item) => (
        <BottomItem key={item?.label_text} title={item?.label_text} imageUrl={item?.image} />
      ))}
    </div>
  );
};

export default HeaderUspBlock;
